module.exports = __webpack_public_path__ + "fonts/Roboto-400-vietnamese5.c0bec65.woff2";